<ng-template #loading>
  <boma-anim-spinning-loader></boma-anim-spinning-loader>
</ng-template>

<!-- {{ supplier | json }} -->
<ng-container *ngIf="supplier; else loading">
  <!--  <h3>CREATE ORDER</h3>-->

  <form
    [formGroup]="createOrderFormGroup"
    class="grid"
    style="min-height: 100%"
  >
    <ng-container *ngIf="!isSubmitting && !error">
      <ng-container
        *ngIf="(supplyingLocation && customer && receivingLocation) || !stepper"
      >
        <div class="col-12 md:col-3 lg:col-2">
          <ng-container *ngTemplateOutlet="orderDetails"></ng-container>
        </div>
        <!-- Product Selector Table -->
        <div class="col-12 md:col-9 lg:col-10">
          <boma-product-selector-table
            *ngIf="supplyingLocation"
            (productsChanged)="handleProductSelectionChange($event)"
            (completeProcess)="createOrder()"
            [showCompleteButton]="true"
            [selectedLocation]="supplyingLocation.id"
            [customerAndLocation]="customerAndLocation"
            [showPrices]="true"
            [submitting]="isSubmitting"
            [showStockLocations]="showStockLocations"
            [checkoutButtonText]="isDebitNote ? 'Create Debit Note' : 'Create Manual Sales Order'"
          ></boma-product-selector-table>
        </div>
      </ng-container>
      <!-- Steppers -->
      <ng-container *ngIf="stepper">
        <ng-container *ngIf="!supplyingLocation">
          <div class="col">
            <div
              style="max-width: 320px; margin: 0 auto"
              *ngIf="!supplyingLocation"
            >
              <h5 class="text-center">
                Please select the
                <br /><span class="is-copy-m text-trade">Order Location</span>.
              </h5>

              <boma-location-search
                (locationSelectedChange)="handleSelectedLocation($event)"
                [multipleLocations]="false"
                placeHolderText="Find Order Location"
              ></boma-location-search>
            </div>
            <!-- TODO Implement favourites -->
            <!-- <div class="flex justify-content-center p-flex-column p-flex-md-row">
          <div class="mr-2 shadow-5 p-5">Favourite</div>
          <div class="mr-2 shadow-5 p-5">Favourite</div>
          <div class="mr-2 shadow-5 p-5">Favourite</div>
          <div class="mr-2 shadow-5 p-5">Favourite</div>
          <div class="shadow-5 p-5">Favourite</div>
        </div> -->
          </div>
        </ng-container>

        <ng-container *ngIf="supplyingLocation && !customer">
          <div class="col">
            <div style="max-width: 320px; margin: 0 auto">
              <h5 class="text-center">
                Please select
                <strong class="is-copy-m text-shop">The Customer</strong>
              </h5>
              <boma-customer-selector
                (selectedItemsChange)="handleSelectedCustomer($event)"
              >
              </boma-customer-selector>
            </div>
          </div>
        </ng-container>

        <ng-container
          *ngIf="supplyingLocation && customer && !receivingLocation"
        >
          <div class="col">
            <div style="max-width: 320px; margin: 0 auto">
              <h5 class="text-center">
                Select the
                <br /><strong class="is-copy-m text-shop"
                  >Receiving Location</strong
                >
                <br />for {{ customer?.name || customer?.registeredName }}
              </h5>
              <p-dropdown
                [(ngModel)]="receivingLocation"
                [filter]="true"
                [ngModelOptions]="{ standalone: true }"
                [options]="customer?.locations"
                [showClear]="true"
                filterBy="name"
                optionLabel="name"
                placeholder="Select Customers Receiving Location"
              ></p-dropdown>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- THIS SHOULD MOVE INTO A MODAL SO THAT WE DONT HAVE TO HIDE THE FORM DOESNT RESET AND RELOAD STOCKS AGAIN... though we are already in a modal... -->
    <ng-container *ngIf="isSubmitting || error">
      <div class="loader">
        <!-- TODO THIS VARIABLE SHOULD JUST LIVE IN A SERVICE SOMEWHERE -->
        <img
          [alt]="supplier.name"
          [src]="
            supplier?.images && supplier?.images.length > 0
              ? supplier.images[0].sizes?.length > 1
                ? (supplier.images | getFirstAvailableImageForSize: '200')
                : (supplier?.images)[0].url
              : '/assets/layout/images/brand/logo-h-dark-text.svg'
          "
          class="logo-image"
          id="app-logo"
        />
        <ng-container *ngIf="isSubmitting">
          <h3>{{ isDebitNote ? 'Processing Debit Note...' : 'Processing Manual Sales Order...' }}</h3>
          <p class="text-center mt-5">
            <boma-anim-spinning-loader [size]="40"></boma-anim-spinning-loader>
          </p>
        </ng-container>
        <ng-container *ngIf="!isSubmitting && error">
          <h3>Failed to create the order.</h3>
          <p class="text-center mt-5">
            {{ error }}
          </p>
          <button
            (click)="error = null"
            pButton
            type="button"
            label="Close"
            class="p-button-warning"
          ></button>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #orderDetails>
      <div class="interface-blue-block mt-3 rounded">
        <div class="formgrid grid p-4">
          <div class="field col-12">
            From: <strong>{{ supplier.name }}</strong>
            <p
              class="flex justify-content-between"
              *ngIf="!editSupplierLocation && supplyingLocation"
            >
              {{ supplyingLocation?.name }}
              <i class="pi pi-pencil" (click)="editSupplierLocation = true"></i>
            </p>
            <div class="pt-1">
              <boma-location-search
                *ngIf="editSupplierLocation || !supplyingLocation"
                (locationSelectedChange)="handleSelectedLocation($event)"
                [multipleLocations]="false"
                placeHolderText="Select Location"
              ></boma-location-search>
            </div>
          </div>
          <div class="field col-12">
            <label>To:</label>
            <boma-customer-selector
              (selectedItemsChange)="handleSelectedCustomer($event)"
              placeHolderText="Select Customer"
              [showLabels]="false"
              [initialCustomers]="this.customer || null"
            >
            </boma-customer-selector>

            <div class="pt-1">
              <span class="p-fluid">
                <p-dropdown
                  [(ngModel)]="receivingLocation"
                  [filter]="true"
                  [ngModelOptions]="{ standalone: true }"
                  [options]="customer?.locations"
                  (onChange)="getPricesForCustomerLocation()"
                  [showClear]="false"
                  [disabled]="!customer"
                  filterBy="name"
                  optionLabel="name"
                  [placeholder]="
                    customer
                      ? 'Customers Receiving Location'
                      : 'No Customer Selected'
                  "
                ></p-dropdown>
              </span>
            </div>
          </div>

          <div class="field col-12">
            <p-selectButton
              [(ngModel)]="selectedPaymentMethod"
              [ngModelOptions]="{ standalone: true }"
              [options]="paymentOptions"
            ></p-selectButton>
          </div>

          <div class="field col-12">
            <label> Comment: </label>
            <span class="p-fluid">
              <input
                placeholder="Comment"
                formControlName="comment"
                pInputText
                type="text"
              />
            </span>
          </div>

          <div class="field col-12">
            <label>
              <span
                [pTooltip]="isDebitNote ? 'Original Order ID is required for Debit Notes' : 'If the client gave you a number for the order enter it here. This can also be used when creating a ZRA LPO (Local Purchase Order).'"
                tooltipPosition="top"
                ><i class="pi pi-question-circle"></i
              ></span>
              {{ isDebitNote ? 'Original Order ID' : 'External Order ID' }}:
              <span *ngIf="isDebitNote" style="color: red;">*</span>
            </label>
            <span class="p-fluid">
              <div class="p-inputgroup" *ngIf="isDebitNote; else normalInput">
                <input
                  [placeholder]="'Enter original order reference (required)'"
                  formControlName="externalOrderId"
                  pInputText
                  type="text"
                  [class.ng-invalid]="isDebitNote && createOrderFormGroup.get('externalOrderId').invalid && createOrderFormGroup.get('externalOrderId').touched"
                  [class.ng-dirty]="isDebitNote && createOrderFormGroup.get('externalOrderId').touched"
                  (blur)="lookupOriginalOrder(createOrderFormGroup.get('externalOrderId').value)"
                />
                <button 
                  pButton 
                  type="button" 
                  icon="pi pi-search" 
                  class="p-button-primary"
                  (click)="lookupOriginalOrder(createOrderFormGroup.get('externalOrderId').value)"
                  [disabled]="!createOrderFormGroup.get('externalOrderId').value || originalOrderLookupLoading"
                  [loading]="originalOrderLookupLoading"
                  pTooltip="Verify order exists"
                  tooltipPosition="top"
                ></button>
                <button 
                  *ngIf="originalOrderFound"
                  pButton 
                  type="button" 
                  icon="pi pi-check" 
                  class="p-button-success"
                  [disabled]="true"
                  pTooltip="Order verified"
                  tooltipPosition="top"
                ></button>
                <button 
                  *ngIf="originalOrderNotFound && !originalOrderLookupLoading"
                  pButton 
                  type="button" 
                  icon="pi pi-times" 
                  class="p-button-danger"
                  [disabled]="true"
                  pTooltip="Order not found"
                  tooltipPosition="top"
                ></button>
              </div>
              <ng-template #normalInput>
                <input
                  [placeholder]="'Enter the reference the customer gave you'"
                  formControlName="externalOrderId"
                  pInputText
                  type="text"
                />
              </ng-template>
            </span>
            <small *ngIf="isDebitNote && createOrderFormGroup.get('externalOrderId').invalid && createOrderFormGroup.get('externalOrderId').touched" class="p-error">
              Original Order ID is required for Debit Notes
            </small>
            <small *ngIf="isDebitNote && originalOrderFound" class="p-success" style="color: green; display: block; margin-top: 0.25rem;">
              <i class="pi pi-check-circle"></i> Order verified: {{ originalOrderFound.reference }}
            </small>
            <small *ngIf="isDebitNote && originalOrderNotFound && !originalOrderLookupLoading" class="p-error">
              <i class="pi pi-times-circle"></i> No fulfilled order found with this Order ID. Please verify and try again.
            </small>
          </div>

          <div class="col-12">
            <label>
              <span
                [pTooltip]="isDebitNote ? 'Debit Note Number will be auto-generated' : 'If you use an external Accounting that is not linked enter the Invoice ID. This can also be used when creating a ZRA LPO (Local Purchase Order).'"
                tooltipPosition="top"
                ><i class="pi pi-question-circle"></i
              ></span>
              {{ isDebitNote ? 'Debit note no (auto-generated)' : 'External Invoice ID' }}:
            </label>
            <span class="p-fluid">
              <input
                formControlName="externalInvoiceId"
                pInputText
                type="text"
                [placeholder]="isDebitNote ? 'Will be auto-generated after submission' : ''"
                [readonly]="isDebitNote"
                [disabled]="isDebitNote"
              />
            </span>
          </div>

          <!-- Currency & Exchange Rate -->
          <div class="field col-12">
            <label>
              <span pTooltip="Select the invoice currency. If different from ZMW, enter the exchange rate." tooltipPosition="top">
                <i class="pi pi-question-circle"></i>
              </span>
              Invoice Currency:
            </label>
            <span class="p-fluid">
              <p-dropdown
                [(ngModel)]="selectedInvoiceCurrency"
                [ngModelOptions]="{ standalone: true }"
                [options]="invoiceCurrencyOptions"
                (onChange)="onInvoiceCurrencyChange()"
                appendTo="body"
                styleClass="w-full"
              ></p-dropdown>
            </span>
          </div>

          <div class="field col-12" *ngIf="selectedInvoiceCurrency !== 'ZMW'">
            <label>
              <span pTooltip="How many units of the selected currency equals 1 ZMW. e.g. 1 ZMW = 0.036 USD" tooltipPosition="top">
                <i class="pi pi-question-circle"></i>
              </span>
              Exchange Rate (1 ZMW = ? {{ selectedInvoiceCurrency }}) <span style="color:red">*</span>:
            </label>
            <span class="p-fluid">
              <p-inputNumber
                [(ngModel)]="invoiceExchangeRate"
                [ngModelOptions]="{ standalone: true }"
                [minFractionDigits]="2"
                [maxFractionDigits]="6"
                [min]="0.000001"
                placeholder="e.g. 0.036"
                styleClass="w-full"
              ></p-inputNumber>
            </span>
            <small style="color:var(--text-color-secondary);">
              Products are priced in ZMW. The invoice will display totals in {{ selectedInvoiceCurrency }}.
            </small>
          </div>

          <div class="col-12" *ngIf="false">
            <p-button
              (click)="createOrder()"
              [disabled]="!products?.length || isSubmitting || error"
              [icon]="isSubmitting ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
              iconPos="left"
              label="Create"
            ></p-button>
          </div>
        </div>
      </div>
    </ng-template>
  </form>
</ng-container>
